import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { ToastComponent, ToastConfig } from '../toast/toast.component';
import { ToastService } from '../../services/toast.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [ToastComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="toast-container">
      @for (toast of toasts; track toast.id) {
        <app-toast
          [config]="toast"
          (closed)="removeToast(toast.id!)">
        </app-toast>
      }
    </div>
  `,
  styles: [`
    .toast-container {
      position: fixed;
      top: 80px;
      right: 16px;
      z-index: 10000;
      display: flex;
      flex-direction: column;
      gap: 12px;
      pointer-events: none;

      > * {
        pointer-events: auto;
      }
    }

    @media (max-width: 480px) {
      .toast-container {
        top: auto;
        bottom: 80px;
        right: 16px;
        left: 16px;
      }
    }
  `]
})
export class ToastContainerComponent implements OnInit, OnDestroy {
  private cdr = inject(ChangeDetectorRef);
  private toastService = inject(ToastService);

  toasts: ToastConfig[] = [];
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.toastService.toasts$
      .pipe(takeUntil(this.destroy$))
      .subscribe(toasts => {
        this.toasts = toasts;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  removeToast(id: string) {
    this.toastService.remove(id);
  }
}
